"use client";

import _asyncToGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createCollectionStore } from "../__chunks/7DTP4AQO.js";
import { createStore, init, setup, throwOnConflictingProps } from "../__chunks/EQQLU3CG.js";
import { applyState, defaultValue, isInteger, isObject } from "../__chunks/PBFD2E7P.js";
import "../__chunks/PQP5VPTV.js";
import { __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/form/form-store.ts
function nextFrame() {
  return new Promise(function (resolve) {
    return requestAnimationFrame(function () {
      return resolve();
    });
  });
}
function hasMessages(object) {
  return Object.keys(object).some(function (key) {
    if (isObject(object[key])) {
      return hasMessages(object[key]);
    }
    return !!object[key];
  });
}
function get(values, path, defaultValue2) {
  var _a;
  var _ref = Array.isArray(path) ? path : "".concat(path).split("."),
    _ref2 = _toArray(_ref),
    key = _ref2[0],
    rest = _ref2.slice(1);
  if (key == null || !values) {
    return defaultValue2;
  }
  if (!rest.length) {
    return (_a = values[key]) != null ? _a : defaultValue2;
  }
  return get(values[key], rest, defaultValue2);
}
function set(values, path, value) {
  var _ref3 = Array.isArray(path) ? path : "".concat(path).split("."),
    _ref4 = _toArray(_ref3),
    k = _ref4[0],
    rest = _ref4.slice(1);
  if (k == null) return values;
  var key = k;
  var isIntegerKey = isInteger(key);
  var nextValues = isIntegerKey ? values || [] : values || {};
  var nestedValues = nextValues[key];
  var result = rest.length && (Array.isArray(nestedValues) || isObject(nestedValues)) ? set(nestedValues, rest, value) : value;
  if (isIntegerKey) {
    var index = Number(key);
    if (values && Array.isArray(values)) {
      return [].concat(_toConsumableArray(values.slice(0, index)), [result], _toConsumableArray(values.slice(index + 1)));
    }
    var nextValues2 = [];
    nextValues2[index] = result;
    return nextValues2;
  }
  return __spreadProps(__spreadValues({}, values), _defineProperty({}, key, result));
}
function setAll(values, value) {
  var result = {};
  var keys = Object.keys(values);
  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var currentValue = values[key];
    if (Array.isArray(currentValue)) {
      result[key] = currentValue.map(function (v) {
        if (isObject(v)) {
          return setAll(v, value);
        }
        return value;
      });
    } else if (isObject(currentValue)) {
      result[key] = setAll(currentValue, value);
    } else {
      result[key] = value;
    }
  }
  return result;
}
function getNameHandler(cache) {
  var prevKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var handler = {
    get: function get(target, key) {
      if (["toString", "valueOf", Symbol.toPrimitive].includes(key)) {
        return function () {
          return prevKeys.join(".");
        };
      }
      var nextKeys = [].concat(_toConsumableArray(prevKeys), [key]);
      var nextKey = nextKeys.join(".");
      if (cache[nextKey]) {
        return cache[nextKey];
      }
      var nextProxy = new Proxy(target, getNameHandler(cache, nextKeys));
      cache[nextKey] = nextProxy;
      return nextProxy;
    }
  };
  return handler;
}
function getStoreCallbacks(store) {
  return store == null ? void 0 : store.__unstableCallbacks;
}
function createNames() {
  var cache = /* @__PURE__ */Object.create(null);
  return new Proxy(/* @__PURE__ */Object.create(null), getNameHandler(cache));
}
function createFormStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  throwOnConflictingProps(props, props.store);
  var syncState = (_a = props.store) == null ? void 0 : _a.getState();
  var collection = createCollectionStore(props);
  var values = defaultValue(props.values, syncState == null ? void 0 : syncState.values, props.defaultValues, {});
  var errors = defaultValue(props.errors, syncState == null ? void 0 : syncState.errors, props.defaultErrors, {});
  var touched = defaultValue(props.touched, syncState == null ? void 0 : syncState.touched, props.defaultTouched, {});
  var initialState = __spreadProps(__spreadValues({}, collection.getState()), {
    values: values,
    errors: errors,
    touched: touched,
    validating: defaultValue(syncState == null ? void 0 : syncState.validating, false),
    submitting: defaultValue(syncState == null ? void 0 : syncState.submitting, false),
    submitSucceed: defaultValue(syncState == null ? void 0 : syncState.submitSucceed, 0),
    submitFailed: defaultValue(syncState == null ? void 0 : syncState.submitFailed, 0),
    valid: !hasMessages(errors)
  });
  var form = createStore(initialState, collection, props.store);
  var syncCallbacks = getStoreCallbacks(props.store);
  var syncCallbacksState = syncCallbacks == null ? void 0 : syncCallbacks.getState();
  var callbacksInitialState = {
    validate: (syncCallbacksState == null ? void 0 : syncCallbacksState.validate) || [],
    submit: (syncCallbacksState == null ? void 0 : syncCallbacksState.submit) || []
  };
  var callbacks = createStore(callbacksInitialState, syncCallbacks);
  setup(form, function () {
    return init(callbacks);
  });
  var validate = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var validateCallbacks, _iterator, _step, callback;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            form.setState("validating", true);
            form.setState("errors", {});
            validateCallbacks = callbacks.getState().validate;
            _context.prev = 3;
            _iterator = _createForOfIteratorHelper(validateCallbacks);
            _context.prev = 5;
            _iterator.s();
          case 7:
            if ((_step = _iterator.n()).done) {
              _context.next = 13;
              break;
            }
            callback = _step.value;
            _context.next = 11;
            return callback(form.getState());
          case 11:
            _context.next = 7;
            break;
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            _iterator.e(_context.t0);
          case 18:
            _context.prev = 18;
            _iterator.f();
            return _context.finish(18);
          case 21:
            _context.next = 23;
            return nextFrame();
          case 23:
            return _context.abrupt("return", !hasMessages(form.getState().errors));
          case 24:
            _context.prev = 24;
            form.setState("validating", false);
            return _context.finish(24);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3,, 24, 27], [5, 15, 18, 21]]);
    }));
    return function validate() {
      return _ref5.apply(this, arguments);
    };
  }();
  return __spreadProps(__spreadValues(__spreadValues({}, collection), form), {
    names: createNames(),
    setValues: function setValues(values2) {
      return form.setState("values", values2);
    },
    getValue: function getValue(name) {
      return get(form.getState().values, name);
    },
    setValue: function setValue(name, value) {
      return form.setState("values", function (values2) {
        var prevValue = get(values2, name);
        var nextValue = applyState(value, prevValue);
        if (nextValue === prevValue) return values2;
        return set(values2, name, nextValue);
      });
    },
    pushValue: function pushValue(name, value) {
      return form.setState("values", function (values2) {
        var array = get(values2, name, []);
        return set(values2, name, [].concat(_toConsumableArray(array), [value]));
      });
    },
    removeValue: function removeValue(name, index) {
      return form.setState("values", function (values2) {
        var array = get(values2, name, []);
        return set(values2, name, [].concat(_toConsumableArray(array.slice(0, index)), [null], _toConsumableArray(array.slice(index + 1))));
      });
    },
    setErrors: function setErrors(errors2) {
      return form.setState("errors", errors2);
    },
    getError: function getError(name) {
      return get(form.getState().errors, name);
    },
    setError: function setError(name, error) {
      return form.setState("errors", function (errors2) {
        var prevError = get(errors2, name);
        var nextError = applyState(error, prevError);
        if (nextError === prevError) return errors2;
        return set(errors2, name, nextError);
      });
    },
    setTouched: function setTouched(touched2) {
      return form.setState("touched", touched2);
    },
    getFieldTouched: function getFieldTouched(name) {
      return !!get(form.getState().touched, name);
    },
    setFieldTouched: function setFieldTouched(name, value) {
      return form.setState("touched", function (touched2) {
        var prevValue = get(touched2, name);
        var nextValue = applyState(value, prevValue);
        if (nextValue === prevValue) return touched2;
        return set(touched2, name, nextValue);
      });
    },
    onValidate: function onValidate(callback) {
      callbacks.setState("validate", function (callbacks2) {
        return [].concat(_toConsumableArray(callbacks2), [callback]);
      });
      return function () {
        callbacks.setState("validate", function (callbacks2) {
          return callbacks2.filter(function (c) {
            return c !== callback;
          });
        });
      };
    },
    validate: validate,
    onSubmit: function onSubmit(callback) {
      callbacks.setState("submit", function (callbacks2) {
        return [].concat(_toConsumableArray(callbacks2), [callback]);
      });
      return function () {
        callbacks.setState("submit", function (callbacks2) {
          return callbacks2.filter(function (c) {
            return c !== callback;
          });
        });
      };
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var submitCallbacks, _iterator2, _step2, callback;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              form.setState("submitting", true);
              form.setState("touched", setAll(form.getState().values, true));
              _context2.prev = 2;
              _context2.next = 5;
              return validate();
            case 5:
              if (!_context2.sent) {
                _context2.next = 29;
                break;
              }
              submitCallbacks = callbacks.getState().submit;
              _iterator2 = _createForOfIteratorHelper(submitCallbacks);
              _context2.prev = 8;
              _iterator2.s();
            case 10:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 16;
                break;
              }
              callback = _step2.value;
              _context2.next = 14;
              return callback(form.getState());
            case 14:
              _context2.next = 10;
              break;
            case 16:
              _context2.next = 21;
              break;
            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](8);
              _iterator2.e(_context2.t0);
            case 21:
              _context2.prev = 21;
              _iterator2.f();
              return _context2.finish(21);
            case 24:
              _context2.next = 26;
              return nextFrame();
            case 26:
              if (hasMessages(form.getState().errors)) {
                _context2.next = 29;
                break;
              }
              form.setState("submitSucceed", function (count) {
                return count + 1;
              });
              return _context2.abrupt("return", true);
            case 29:
              form.setState("submitFailed", function (count) {
                return count + 1;
              });
              return _context2.abrupt("return", false);
            case 33:
              _context2.prev = 33;
              _context2.t1 = _context2["catch"](2);
              form.setState("submitFailed", function (count) {
                return count + 1;
              });
              throw _context2.t1;
            case 37:
              _context2.prev = 37;
              form.setState("submitting", false);
              return _context2.finish(37);
            case 40:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 33, 37, 40], [8, 18, 21, 24]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    reset: function reset() {
      form.setState("values", values);
      form.setState("errors", errors);
      form.setState("touched", touched);
      form.setState("validating", false);
      form.setState("submitting", false);
      form.setState("submitSucceed", 0);
      form.setState("submitFailed", 0);
    },
    // @ts-expect-error Internal
    __unstableCallbacks: callbacks
  });
}
export { createFormStore, get, hasMessages };